import React from "react";

import { PasswordResetPhoneForm } from "@/mk2/apps/users/containers/PasswordResetPhone/PasswordResetPhoneForm";
import { Props } from "@/mk2/apps/users/containers/PasswordResetPhone/PasswordResetPhonePage";
import {
    PASSWORD_RESET_PHONE_EXPLANATION_CALL_price,
    PASSWORD_RESET_PHONE_EXPLANATION_SMS_price,
    PASSWORD_RESET_PHONE_TITLE,
} from "@/mk/autogenerated/translation";

import styles from "./PasswordResetPhone.mscss";

export class PasswordResetPhone extends React.Component<Props> {
    public render() {
        const { onRequestToken, onValidateToken, initialValues, currentValues, location } =
            this.props;

        return (
            <div className={styles.PasswordResetPhone}>
                <PasswordResetPhoneForm
                    step1Title={PASSWORD_RESET_PHONE_TITLE}
                    step1ExplanationSms={PASSWORD_RESET_PHONE_EXPLANATION_SMS_price}
                    step1ExplanationCall={PASSWORD_RESET_PHONE_EXPLANATION_CALL_price}
                    initialValues={initialValues}
                    currentValues={currentValues}
                    onRequestToken={onRequestToken}
                    onValidateToken={onValidateToken}
                    location={location}
                />
            </div>
        );
    }
}
